<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('pages.options.key')">
              <b-form-input type="text" v-model="$v.createForm.key.$model" :state="!$v.createForm.key.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.key.required">
                {{ $t('formErrors.enterKey') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.options.value')">
              <b-form-input type="text" v-model="$v.createForm.value.$model" :state="!$v.createForm.value.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.value.required">
                {{ $t('formErrors.enterValue') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    createForm: {
      key: '',
      value: ''
    }
  }),
  validations: {
    createForm: {
      key: { required },
      value: { required }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('options/createOption', {
          payload: this.createForm,
          vm: this
        })
      }
    }
  }
}
</script>
